// extracted by mini-css-extract-plugin
export default {"buttons":"PrevNextButtons_buttons__Ueb2B"};